import {RoadsoftSubscription} from "../../../app/api/model/roadsoft";
import {ChipTypeMap} from "@mui/material/Chip/Chip";
import {TFunction} from "i18next";
import {Chip} from "@mui/material";
import {ReactNode} from "react";
import {camelCase} from "lodash";

export const getSubscriptionLabel = (
    subscription: RoadsoftSubscription,
    t: TFunction,
    size: ChipTypeMap["props"]["size"] = "small"
): ReactNode => {
    const translatedsubScription = t(`roadsoft_subscription${camelCase(subscription)}`);

    let content;

    switch (subscription) {
        case RoadsoftSubscription.TASK_MANAGER:
        case RoadsoftSubscription.PREMIUM:
            content = <Chip label={translatedsubScription} color={"info"} size={size} variant={"filled"} />;
            break;
        case RoadsoftSubscription.NOT_BOOKED:
            content = <Chip label={translatedsubScription} color={"error"} size={size} variant={"filled"} />;
            break;
        default:
            content = <Chip label={translatedsubScription} color={"default"} size={size} variant={"filled"} />;
            break;
    }

    return <>{content}</>;
};
